import { render } from "./AppointmentForm.vue?vue&type=template&id=542509ed&scoped=true&ts=true"
import script from "./AppointmentForm.vue?vue&type=script&lang=ts"
export * from "./AppointmentForm.vue?vue&type=script&lang=ts"

import "./AppointmentForm.vue?vue&type=style&index=0&id=542509ed&scoped=true&lang=css"

import exportComponent from "/app/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-542509ed"]])

export default __exports__